import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import AddressView from "../Address/AddressView";

interface DynamicAddressRouteProps {
  updateUserName: (newUserName: string) => void;
  showSidebar?: boolean;
  showHeader?: boolean;
}

const DynamicAddressRoute: React.FC<DynamicAddressRouteProps> = ({
  updateUserName,
  showSidebar = false,
  showHeader = false
}) => {
  const { pamCode } = useParams<{ pamCode: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  const [redirecting, setRedirecting] = useState(true);

  const isAuthenticated = () => {
    const token = localStorage.getItem("authToken") || localStorage.getItem("token");
    return !!token;
  };

  useEffect(() => {
    if (!pamCode) {
      setRedirecting(false);
      return;
    }

    const authenticated = isAuthenticated();
    const isAddressRoute = location.pathname.startsWith("/address/");

    if (authenticated && !isAddressRoute) {
      navigate(`/address/${pamCode}`, { replace: true });
    } else if (!authenticated && isAddressRoute) {
      navigate(`/${pamCode}`, { replace: true });
    } else {
      setRedirecting(false);
    }
  }, [pamCode, navigate, location.pathname]);

  if (redirecting) {
    return (
      <main className="container mx-auto px-4 py-6">
        <div className="bg-white rounded-md p-4 md:p-6">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-500 text-lg">Loading address...</p>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <AddressView
      updateUserName={updateUserName}
      showSidebar={showSidebar}
      showHeader={showHeader}
    />
  );
};

export default DynamicAddressRoute;
